<template>
  <div class="hidden xl:flex items-center p-1 space-x-1 bg-gray-100 overflow-x-auto whitespace-nowrap scrollbar-none flex-nowrap select-none border-b border-gray-200">
    <div
      v-for="tab in tabStore.tabs"
      :key="tab.path"
      class="flex-shrink-0 inline-flex items-center px-2.5 py-1 xl:py-0.5 mx-0.5 xl:mx-1 my-1 xl:my-1.5 transition-all text-xs xl:text-sm rounded"
      :class="{
        'text-blue-600 bg-white font-bold border border-blue-500 shadow-sm': tab.path === tabStore.activePath,
        'bg-gray-100 text-gray-700 border border-gray-300 hover:text-blue-500 hover:bg-white hover:border-blue-300': tab.path !== tabStore.activePath,
      }"
    >
      <span @click="tabNavigate(tab.path)" class="cursor-pointer mr-1.5 truncate max-w-[140px] xl:max-w-none">
        {{ tab.name }}
      </span>
      <button
        @click="tabClose(tab.path)"
        class="ml-0.5 flex items-center justify-center p-0.5 hover:bg-red-50 rounded-full focus:outline-none"
        v-show="tab.path !== '/scm/home'"
        aria-label="탭 닫기"
      >
        <div
          class="w-4 h-4"
          :class="{
            'bg-blue-500 hover:bg-red-500': tab.path === tabStore.activePath,
            'bg-gray-400 hover:bg-red-500': tab.path !== tabStore.activePath,
          }"
          :style="{ 
            maskImage: `url(${CloseIcon})`, 
            WebkitMaskImage: `url(${CloseIcon})`,
            maskSize: 'cover',
            WebkitMaskSize: 'cover'
          }"
        ></div>
      </button>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

import { useRouter } from "vue-router";
import { useTabStore } from "@/store/tabStore";

import CloseIcon from "@/assets/img/close-circle.svg";

import { XMarkIcon } from "@heroicons/vue/24/solid";

const router = useRouter();
const tabStore = useTabStore();

onMounted(() => {
  // console.log("✅ mounted 됨 (script setup)");
  // console.log("mounted tabStore", tabStore.path);
});

const tabNavigate = (path) => {
  // console.log("tabNavigate", path);
  // console.log("tabStore.tabs", tabStore.activePath);

  router.push(path);
  tabStore.setActiveTab(path);
};

const tabClose = (path) => {
  // console.log("tabClose", path);

  // 닫은 탭이 현재 활성 탭이라면 이전 탭으로 이동
  if (tabStore.activePath === path) {
    tabStore.removeTab(path);

    const tabs = tabStore.tabs;
    if (tabs.length > 0) {
      const lastTab = tabs[tabs.length - 1];

      tabStore.setActiveTab(lastTab.path);
      router.push(lastTab.path);
    } else {
      // 탭이 모두 닫혔을 경우 fallback 경로
      router.push("/"); // or login or default path
    }
  } else {
    tabStore.removeTab(path);
  }
};
</script>

<style scoped>
.scrollbar-none::-webkit-scrollbar {
  display: none;
}
.scrollbar-none {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
